import { useReactiveVar } from '@apollo/client';
import { user } from '../../utils/reactiveVars';

const useOswVisible = () => {
  const currentUser = useReactiveVar(user);

  return currentUser?.oswVisible !== false;
};

export default useOswVisible;
